module.exports = __webpack_public_path__ + "img/close.57933ed4.svg";